export var DocumentTypeFormat;
(function (DocumentTypeFormat) {
    DocumentTypeFormat["SINGLE"] = "SINGLE";
    DocumentTypeFormat["FRONT_BACK"] = "FRONT_BACK";
    DocumentTypeFormat["MULTIPLE"] = "MULTIPLE";
})(DocumentTypeFormat || (DocumentTypeFormat = {}));
